import { render, staticRenderFns } from "./vendorLaunchDetails.vue?vue&type=template&id=64ed36a4&scoped=true"
import script from "./vendorLaunchDetails.vue?vue&type=script&lang=js"
export * from "./vendorLaunchDetails.vue?vue&type=script&lang=js"
import style0 from "./vendorLaunchDetails.vue?vue&type=style&index=0&id=64ed36a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ed36a4",
  null
  
)

export default component.exports